import Chart from 'react-apexcharts';
import React, { Component, Fragment } from 'react';

class MeetingUsageChart extends Component {

  async componentDidMount() {
  }

  render() {

    const barChartConfig = {
      chart: {
        animations: { enabled: false },
        height: "100%",
        toolbar: { show: false }
      },
      dataLabels: { enabled: false },
      legend: { position: "left", show: true, width: 150, showForSingleSeries: true, markers: { fillColors: ['#00E396', '#775DD0'], }, customLegendItems: ['All users', 'Active in meetings'],},
      markers: { size: 3, strokeColors: '#fff', strokeWidth: 1, shape: "circle", radius: 2, },
      colors: ["#79DE79"]
    };

    return (
      <Fragment >
              <span className="pl-3 d-block font-weight-bold">{this.props.chartdata.title} </span>
              <Chart options={barChartConfig} series={this.props.chartdata.series} type="bar" height="300"/>
        </Fragment>
    ); // end of return
  } // end of render()
} // end of class

export default MeetingUsageChart;
